import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_q_btn = _resolveComponent("q-btn")!
  const _component_q_form = _resolveComponent("q-form")!

  return (_openBlock(), _createBlock(_component_q_form, {
    greedy: "",
    ref: "form"
  }, {
    default: _withCtx(() => [
      (_ctx.isInvoicingManager)
        ? (_openBlock(), _createBlock(_component_q_btn, {
            key: 0,
            label: "Revoke",
            onClick: _ctx.showConfirmRevokeDialog,
            color: "negative",
            unelevated: "",
            "no-caps": ""
          }, null, 8, ["onClick"]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }, 512))
}